import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from '@configuration/app.component';
import { CoreModule } from '@configuration/core/core.module';
import { environment } from '@environment/environment';
import { CookieConsentComponent } from '@shared/components/cookie-consent/cookie-consent.component';
import { UpdateBannerComponent } from '@shared/components/update-banner/update-banner.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    UpdateBannerComponent,
    CookieConsentComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.ENABLE_SERVICE_WORKER,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    }
  ]
})

export class AppModule {}
